import React, { useEffect, useState } from 'react';
import { Table, Checkbox, message, Tooltip, Typography, Button, Space } from 'antd';
import { CRotationSkipProvider } from '../../domain/usdt-providers/cRotationSkipProvider';
import { OperationWalletProvider } from '../../domain/usdt-providers/operationWalletProvider';
import { GlobalSettingProvider } from '../../domain/usdt-providers/globalSettingProvider';
import { CSuccessRateDrawer } from '../components/CSuccessRateDrawer';

const tail = (a: string) => '…' + a.slice(-6);
const rkey = (f: string, t: string) => `${f}|${t}`;

// 出款 C 地址跳過矩陣:行=啟用中出款錢包,列=出款 C 輪替名單,勾=該錢包跳過該 C 地址。
// 成功率移到「成功率」按鈕 → Drawer 看(帶時間範圍/筆數)。
export default function CRotationSkipMatrix({ title }: { title?: string }) {
  const [wallets, setWallets] = useState<string[]>([]);
  const [cAddrs, setCAddrs] = useState<string[]>([]);
  const [idMap, setIdMap] = useState<Map<string, string>>(new Map());
  const [loading, setLoading] = useState(false);
  const [rateOpen, setRateOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [wr, gr, skips] = await Promise.all([
        OperationWalletProvider.list('TRC'),
        GlobalSettingProvider.get(),
        CRotationSkipProvider.list('payout'),
      ]);
      const ws = (wr.data || [])
        .filter((w) => w.type === 'PAYOUT' && !!w.enabled)
        .map((w) => w.address);
      const gs: any = gr.data || {};
      const raw: string =
        gs.PAYOUT_C_ROTATION_RECEIVERS || gs.C_ROTATION_RECEIVERS || '';
      const cs = raw.split(',').map((s) => s.trim()).filter(Boolean);
      setWallets(ws);
      setCAddrs(cs);
      setIdMap(new Map(skips.map((s) => [rkey(s.fromAddress, s.toAddress), s.id])));
    } catch (e: any) {
      message.error(e?.message ?? '載入失敗');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = async (from: string, to: string, checked: boolean) => {
    const k = rkey(from, to);
    try {
      if (checked) {
        const rec = await CRotationSkipProvider.add({
          scope: 'payout',
          fromAddress: from,
          toAddress: to,
        });
        setIdMap((m) => new Map(m).set(k, rec.id));
      } else {
        const id = idMap.get(k);
        if (id) await CRotationSkipProvider.remove(id);
        setIdMap((m) => {
          const n = new Map(m);
          n.delete(k);
          return n;
        });
      }
    } catch (e: any) {
      message.error(e?.message ?? '操作失敗');
      load(); // 失敗回原狀
    }
  };

  const columns: any[] = [
    {
      title: '出款錢包 \\ C地址',
      key: '__w',
      fixed: 'left',
      render: (_: any, row: { w: string }) => (
        <Tooltip title={row.w}>{tail(row.w)}</Tooltip>
      ),
    },
    ...cAddrs.map((c) => ({
      title: <Tooltip title={c}>{tail(c)}</Tooltip>,
      key: c,
      align: 'center',
      render: (_: any, row: { w: string }) => (
        <Checkbox
          checked={idMap.has(rkey(row.w, c))}
          onChange={(e) => toggle(row.w, c, e.target.checked)}
        />
      ),
    })),
  ];

  return (
    <div style={{ padding: 16 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title ?? '出款 C 地址跳過'}
        </Typography.Title>
        <Button onClick={() => setRateOpen(true)}>成功率</Button>
      </Space>
      <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
        勾選 = 該出款錢包輪詢時跳過該 C 地址(即時生效)。行=啟用中出款錢包,列=出款 C 輪替名單。
        成功率請點右上「成功率」查看。
      </Typography.Paragraph>
      <Table
        rowKey="w"
        loading={loading}
        pagination={false}
        scroll={{ x: true }}
        dataSource={wallets.map((w) => ({ w }))}
        columns={columns}
      />
      <CSuccessRateDrawer
        scope="payout"
        title="出款 C 供能成功率"
        visible={rateOpen}
        onClose={() => setRateOpen(false)}
      />
    </div>
  );
}
